import React from 'react'
import { InputNumber } from 'primereact/inputnumber'

export default function LtsCurrency(props) {
  const { onChange, onBlur, inputProps: inputPropsProp, ...restProps } = props

  const parseNumericValue = (raw) => {
    if (raw == null) return null
    if (typeof raw === 'number' && !Number.isNaN(raw)) return raw
    const str = String(raw).trim()
    if (!str) return null

    const normalized = str
      .replace(/\s/g, '')
      .replace(/R\$/gi, '')
      .replace(/\./g, '')
      .replace(/,/g, '.')
      .replace(/[^0-9.-]/g, '')

    if (!normalized) return null
    const n = Number(normalized)
    return Number.isNaN(n) ? null : n
  }

  const resolveName = () => {
    return props.name || 'valor'
  }

  const resolveInputId = () => {
    return props.inputId || resolveName()
  }

  const resolveLabel = () => {
    if (props.label) {
      return <label htmlFor={resolveInputId()}>{props.label}</label>
    }
    return null
  }

  const resolveMode = () => {
    if (props.mode) {
      return props.mode
    }
    return 'currency'
  }

  return (
    <React.Fragment>
      <span className="p-float-label">
        <InputNumber
          {...restProps}
          inputId={resolveInputId()}
          mode={resolveMode()}
          currency="BRL"
          minFractionDigits={props?.minFractionDigits ?? 2}
          value={props.value}
          allowEmpty={props.allowEmpty ?? true}
          onValueChange={(e) => onChange?.(e.value)}
          onChange={(e) => onChange?.(e.value)}
          onBlur={(e) => {
            const current = typeof props.value === 'number' && !Number.isNaN(props.value) ? props.value : null
            if (current == null) {
              const parsed = parseNumericValue(e?.target?.value)
              if (parsed !== current) onChange?.(parsed)
            }
            onBlur?.(e)
          }}
          name={resolveName()}
          inputProps={{
            ...(inputPropsProp || {}),
            autoComplete: (inputPropsProp && inputPropsProp.autoComplete) || 'off',
          }}
        />
        {resolveLabel()}
      </span>
    </React.Fragment>
  )
}
